// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style__wrapper__6HlpR","reportBodyText":"style__reportBodyText__8zKQ9"};